// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import type { RootState } from 'Store';

export const selectIsSelected = (state: RootState, kind: FileSelectionKind, id: string): boolean =>
  state.fileSelection.selected[kind].includes(id);

export const selectIsHoveredFromMap = (state: RootState, kind: FileSelectionKind, id: string): boolean => {
  const { hovered } = state.fileSelection;
  return !!hovered && hovered.source === 'map'
    && hovered.files.some((f) => f.kind === kind && f.id === id);
};

// Only the topmost hovered file auto-scrolls its sidebar row: scrolling every
// row of an overlap stack would fight itself.
export const selectIsTopHoveredFromMap = (state: RootState, kind: FileSelectionKind, id: string): boolean => {
  const { hovered } = state.fileSelection;
  return !!hovered && hovered.source === 'map'
    && hovered.files[0]?.kind === kind && hovered.files[0]?.id === id;
};
